import { VueExtension } from '../../utils/extensions/vue';
import Radio from './radio.jsx';
import './radio.scss';

VueExtension.WithInstall(Radio);

export default Radio;
